import { render, staticRenderFns } from "./StepByStepComponent.vue?vue&type=template&id=dbbc2072&lang=pug"
import script from "./StepByStepComponent.vue?vue&type=script&lang=js"
export * from "./StepByStepComponent.vue?vue&type=script&lang=js"
import style0 from "./StepByStepComponent.vue?vue&type=style&index=0&id=dbbc2072&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports